import Vue from 'vue';
import Router from 'vue-router';
import lodash from 'lodash';
import Moment from 'moment';
import rules from '@/utils/rules';
import Viewer from 'v-viewer';
import TlbsMap from 'tlbs-map-vue';
import tencentMapApi from '@/api/System/tencentMap';
import { loadTdtMapScript } from '@/utils/loadTiandituMap';
import i18n from './i18n/i18n';
import App from './App.vue';
import router from './router';
import store from './store/index';
import 'vue-slider-component/theme/default.css';
import components from './utils/components';
import methods from './utils/methods';
import 'viewerjs/dist/viewer.css';

// 验证规则可在 rules.js文件添加
import '@/utils/directive';
// 权限
import './permission';

// 自定义主题
// import 'iview/dist/styles/iview.css';
import '@/theme/index.less';

Vue.use(TlbsMap);

Vue.use(Viewer);
// import './theme/dist/iview.css';
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
Vue.config.productionTip = false;
Vue.prototype.$rules = rules;
Vue.prototype._ = lodash;
Vue.prototype.$moment = Moment;
Vue.prototype.$baseUrl = process.env.VUE_APP_REQUEST_BASE_URL;

// 组件注册
Vue.use(components);
// 方法注册
Vue.use(methods);

function loadGeolocationScript(key) {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[data-tencent-map="geolocation"]')) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://apis.map.qq.com/tools/geolocation/min?key=${key}&referer=2175`;
    script.setAttribute('data-tencent-map', 'geolocation');
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Tencent Map geolocation script'));
    document.head.appendChild(script);
  });
}

const vue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

async function initApp() {
  try {
    const res = await tencentMapApi.getTencentMapKey();
    if (res && res.data) {
      const { tencentMapKey, tiandituMapKey } = res.data;
      if (tencentMapKey) {
        store.commit('updateTencentMapKey', tencentMapKey);
        await loadGeolocationScript(tencentMapKey);
      }
      if (tiandituMapKey) {
        store.commit('updateTiandituMapKey', tiandituMapKey);
        await loadTdtMapScript(tiandituMapKey);
      }
    }
  } catch (error) {
    console.error('Failed to fetch Tencent Map key:', error);
  }
}

initApp();

export default vue;
